import React from 'react';
import { ArrowLeftIcon } from 'lucide-react';
export const MinimalHeader = () => {
  return <header className="bg-[#111010] py-4 md:py-5 sticky top-0 z-50 shadow-md" data-id="element-364">
      <div className="max-w-[1200px] mx-auto px-4 flex items-center justify-between" data-id="element-365">
        <div className="flex items-center" data-id="element-366">
          <a href="https://btbbouwbedrijf.nl" className="flex items-center justify-center md:justify-start" data-id="element-367">
            <img src="https://btbbouwbedrijf.nl/wp-content/uploads/2020/05/Logo-Transparency-WHITE.png" alt="BTB Bouwbedrijf Logo" className="h-12 md:h-14" data-id="element-368" />
          </a>
        </div>
        <a href="https://btbbouwbedrijf.nl" className="flex items-center text-white hover:text-[#FCCA86] transition-colors duration-200" data-id="element-369">
          <ArrowLeftIcon className="h-5 w-5 mr-2" data-id="element-370" />
          <span className="hidden sm:inline" data-id="element-371">Terug naar website</span>
        </a>
      </div>
    </header>;
};